import React from 'react'
import settings from 'popups/Settings'
import moment from 'moment'
import styles from './style.module.scss'
import { useTranslation } from 'react-i18next'

interface CalendarSettings {
  showSecondaryTimezone: boolean
  primaryTimezone?: string
  primaryTimezoneLabel?: string
  secondaryTimezone?: string
  secondaryTimezoneLabel?: string
}

const TimezoneNameBlock: React.FC<any> = ({ targetDate }) => {
  const { t } = useTranslation()
  const calSettings = settings.getValue('calendar') as CalendarSettings
  const showSecondTz = calSettings.showSecondaryTimezone
  const primaryTzId =
    calSettings.primaryTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  const secondaryTzId = calSettings.secondaryTimezone

  const getPrimaryTimezoneName = (): string => {
    if (calSettings.primaryTimezoneLabel) {
      return calSettings.primaryTimezoneLabel
    }
    /* i18next-extract-disable-next-line */
    return t('timezone.' + primaryTzId)
  }

  const getSecondaryTimezoneName = (): string => {
    if (calSettings.secondaryTimezoneLabel) {
      return calSettings.secondaryTimezoneLabel
    }
    /* i18next-extract-disable-next-line */
    return t('timezone.' + secondaryTzId)
  }

  const getOffset = (): string | null => {
    const tzId = calSettings.secondaryTimezone
    if (tzId == null) {
      return null
    }

    const tDate = targetDate instanceof Date ? new Date(targetDate) : new Date()
    tDate.setHours(0, 0, 0, 0)

    const tz = moment(tDate).tz(tzId)
    const secondaryOffset = tz.utcOffset()
    const primaryOffset = moment(tDate).tz(primaryTzId).utcOffset()

    const offset = secondaryOffset - primaryOffset
    if (offset === 0) {
      return null
    }

    const absOffset = Math.abs(offset)
    const hours = Math.floor(absOffset / 60)
    const minutes = Math.abs(absOffset % 60)

    let offsetStr = offset > 0 ? '+' : '-'
    if (minutes > 0) {
      offsetStr += `${hours}:${minutes}`
    } else {
      if (hours > 0) {
        if (hours === 1) {
          offsetStr += '1 ' + t('calendar.time.hr')
        } else {
          offsetStr += hours + ' ' + t('calendar.time.hrs')
        }
      }
    }
    return offsetStr
  }

  return (
    <div className={styles.timezoneNameCell}>
      {showSecondTz && <div className={styles.primaryTimezoneName}>{getPrimaryTimezoneName()}</div>}
      {showSecondTz && calSettings.secondaryTimezone && (
        <div className={styles.secondaryTimezoneNameContainer}>
          <div className={styles.secondaryTimezoneName}>{getSecondaryTimezoneName()}</div>
          <div className={styles.secondaryTimezoneName}>{getOffset()}</div>
        </div>
      )}
    </div>
  )
}

export default TimezoneNameBlock
